module.exports = __webpack_public_path__ + "static/media/07Bar.af68c933.svg";